import { atom } from 'jotai';

import { DetentionFormState } from '~/modules/transportation/types';

const initialState: DetentionFormState = {
  carrierId: '',
  carrierName: '',
  locationId: '',
  locationName: '',
  startDate: undefined,
  endDate: undefined,
  freeMinutes: 0,
  ratePerMinute: '0',
};

export const $detentionForm = atom<DetentionFormState>(initialState);

export const $resetDetentionForm = atom(null, (get, set) => {
  set($detentionForm, initialState);
});

export const $updateDetentionForm = atom(
  null,
  (get, set, update: Partial<DetentionFormState>) => {
    const currentState = get($detentionForm);
    set($detentionForm, { ...currentState, ...update });
  },
);
